// NOTICE: KAPTION-INTEGRATION
// Composable for getting user's effective language preference
// Priority: ui_settings.locale → account locale → 'en'

import { computed } from 'vue';
import { useStore } from 'vuex';
import { useAccount } from './useAccount';

/**
 * Get user's effective language preference
 *
 * @returns {Object} Object containing reactive language preference
 *
 * @example
 * import { useUserLanguage } from 'dashboard/composables/useUserLanguage';
 *
 * const { userLanguage } = useUserLanguage();
 * console.log(userLanguage.value); // 'en', 'es', 'fr', etc.
 */
export function useUserLanguage() {
  const store = useStore();
  const { currentAccount } = useAccount();

  // Get current user from store
  const currentUser = computed(() => store.getters.getCurrentUser);

  // Get user's effective language
  const userLanguage = computed(() => {
    // Priority 1: User's ui_settings locale
    const userLocale = currentUser?.value?.ui_settings?.locale;
    if (userLocale && typeof userLocale === 'string') {
      const normalized = userLocale.split('_')[0]?.toLowerCase?.() || 'en';
      // Normalize locale (e.g., 'pt_BR' -> 'pt')
      return normalized;
    }

    // Priority 2: Account locale
    const accountLocale = currentAccount?.value?.locale;
    if (accountLocale && typeof accountLocale === 'string') {
      const normalized = accountLocale.split('_')[0]?.toLowerCase?.() || 'en';
      // Normalize locale (e.g., 'pt_BR' -> 'pt')
      return normalized;
    }

    // Priority 3: Default to English
    return 'en';
  });

  return {
    userLanguage,
  };
}
